import React from 'react';
import { LuSparkles, LuWandSparkles } from 'react-icons/lu';
import SegmentedControl from '../ui/SegmentedControl';
import { analysisTitle, isCustomAnalysis, sortAnalysesByConfig } from './analysisContent.js';

/** Analysis switcher, in the order of the client's configuration. Custom analyses get a wand. */
export const AnalysisTabs = ({ analyses, activeType, onActiveTypeChange, client }) => {
  const sorted = sortAnalysesByConfig(analyses, client?.weekly_config);
  if (sorted.length < 2) return null;
  return (
    <SegmentedControl
      ariaLabel="Analyses du rapport"
      value={activeType}
      onChange={(type) => onActiveTypeChange?.(type)}
      options={sorted.map((analysis) => ({
        value: analysis.type,
        label: analysisTitle(analysis, client?.weekly_config),
        icon: isCustomAnalysis(analysis) ? LuWandSparkles : LuSparkles,
      }))}
    />
  );
};

export default AnalysisTabs;
